import { ConfigEnvironmentVariableLinksResponseInterface } from '@types';
import { appEnvironmentActionTypes } from '@actions/actionTypes/appEnvironment';

export const setConfigVariables = (payload: ConfigEnvironmentVariableLinksResponseInterface) => {
  return {
    type: appEnvironmentActionTypes.SET_CONFIG_VARIABLES,
    payload,
  };
};
